import { jsx } from "react/jsx-runtime";
import { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { MotionConfig, AnimatePresence } from "framer-motion";
import { easeQuadOut } from "d3-ease";
import { values } from "lodash/fp";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import { toastContext } from "../../contexts/toast-context/toast-context.es.js";
import { ToastImpl } from "./toast-impl.es.js";
const propTypes = {
  id: PropTypes.string,
  placement: PropTypes.oneOf(["top", "bottom"])
};
const defaultProps = {
  id: void 0,
  placement: "top"
};
const Toaster = ({ id, placement }) => {
  const { toastMap } = useContext(toastContext);
  const toasts = toastMap[id];
  const toasterItems = useMemo(() => values(toasts), [toasts]);
  return /* @__PURE__ */ jsx(MotionConfig, { transition: { ease: easeQuadOut, duration: 0.3 }, children: /* @__PURE__ */ jsx(AnimatePresence, { children: toasterItems.map((item, index) => /* @__PURE__ */ jsx(
    ToastImpl,
    {
      clickable: item.clickable,
      index,
      placement,
      onClick: item.onDismiss,
      variant: item.variant,
      children: item.message
    },
    item.id
  )) }) });
};
Toaster.propTypes = propTypes;
Toaster.defaultProps = defaultProps;
export {
  Toaster
};
